export function construct<T, U>(target: T, source: U) {
    Object.getOwnPropertyNames(source).forEach((key) => {
        // @ts-ignore
        if (source[key] !== undefined && source[key] !== null) target[key] = source[key];
    });
}

export function createArrayInstance<T>(Clazz: new (x: T) => T, list?: T[]) {
    if (!list) return;

    return list.map(el => {
        if (el instanceof Clazz) {
            return el;
        } else {
            return new Clazz(el);
        }
    });
}

export function createInstance<T>(Clazz: new(x: T) => T, entity?: T) {
    if (!entity) return;
    if (entity instanceof Clazz) return entity;
    return new Clazz(entity);
}

export type ModelProperties<T> =
// tslint:disable-next-line:no-any
    Omit<Pick<T, { [K in keyof T]: T[K] extends (_: any) => any ? never : K }[keyof T]>, 'id' | 'createdAt' | 'updatedAt'>;

export const models = {
    construct,
    createArrayInstance,
    createInstance,
};